export const VIDEO_RESET = "VIDEO_RESET" as const;
export const VIDEO_ALL_SET = "VIDEO_ALL_SET" as const;
export const VIDEO_SET = "VIDEO_SET" as const;
